import React, { useMemo } from 'react';
import { InfoModal } from '../../../../theme/components';
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Skeleton,
} from '@mui/material';
import { getTranslationNameByData } from '../../../../redux/monitoring/api/util/getLabelName';
import { useCUsTranslate } from '../../../../redux/CUTranslation/hook/useCUsTranslate';
import { getPolyglot } from '../../../../i18n';
import { isNotNullOrUndefined } from '../../../../util/types/Array';
import { CHANNEL_TYPE } from '../../../../redux/reports/api/Report.model';
import { SelectChannelModalProps } from './SelectChannelModal';
import useChannelsFromComposableDevice from '../../../../redux/composableDevice/hooks/useChannelsFromComposableDevice';

function SelectChannelModalComposableDevice(props: SelectChannelModalProps) {
  const { onSelectItem, groupId } = props;
  const [CUsTranslate, loadingTranslations] = useCUsTranslate();
  const polyglot = getPolyglot();

  const { data: composableChannels, isLoading: loadingComposableChannels } =
    useChannelsFromComposableDevice(groupId ?? '');
  const analogChannels = useMemo(
    () =>
      composableChannels.filter(
        (channel) => channel.type === CHANNEL_TYPE.ANALOG
      ),
    [composableChannels]
  );

  const loading = loadingComposableChannels;
  return (
    <InfoModal {...props} maxWidth="sm" fullWidth>
      <Box className="DigitalChannelFilters" sx={{ width: '100%' }}>
        {loading && (
          <Skeleton variant="rectangular" width="560px" height={118} />
        )}
        <List>
          {analogChannels.map((channel) => {
            const primaryText =
              channel.name ??
              getTranslationNameByData(
                undefined,
                channel.channelID,
                CUsTranslate,
                channel.deviceID,
                channel.cuID
              );

            const longTranslation =
              (CUsTranslate(
                channel.channelID,
                channel.deviceID,
                channel.cuID,
                'ram',
                'longText',
                false,
                true
              ) as string) ||
              (CUsTranslate(
                channel?.name ?? channel.channelID,
                channel.deviceID,
                channel.cuID,
                'parameters',
                'longText',
                false,
                true
              ) as string);

            const secondaryText = channel.name
              ? undefined
              : [
                  channel.channelID
                    ? `${polyglot.t('device.monitoring.id_taq')}: ${
                        channel.channelID
                      }`
                    : undefined,
                  channel.name
                    ? `${polyglot.t('device.monitoring.name_taq')}: ${
                        channel.name
                      }`
                    : undefined,
                  longTranslation
                    ? `${polyglot.t(
                        'device.monitoring.description_taq'
                      )}: ${longTranslation}`
                    : undefined,
                ]
                  .filter(isNotNullOrUndefined)
                  .join(', ');

            return (
              <ListItemButton
                key={`${channel.deviceID}-${channel.cuID}-${channel.channelID}`}
                className={`DigitalChannelFilters__Event Event-${channel.deviceID}-${channel.cuID}-${channel.channelID}`}
                role={undefined}
                onClick={() =>
                  onSelectItem({
                    deviceID: channel.deviceID,
                    cuID: channel.cuID,
                    channelID: channel.channelID,
                    type: channel.type as CHANNEL_TYPE,
                  })
                }
                // dense
              >
                {loadingTranslations ? (
                  <Skeleton width="100%" height={24} />
                ) : (
                  <ListItemText
                    id={`event-title-${channel.deviceID}-${channel.cuID}-${channel.channelID}-label`}
                    primary={primaryText}
                    secondary={secondaryText}
                    primaryTypographyProps={{
                      sx: { wordBreak: 'break-all' },
                    }}
                    secondaryTypographyProps={{
                      sx: { wordBreak: 'break-all' },
                    }}
                  />
                )}
              </ListItemButton>
            );
          })}
        </List>
      </Box>
    </InfoModal>
  );
}

export default SelectChannelModalComposableDevice;
